<template>
  <el-dialog
    custom-class="system_manager_dialog"
    title="修改帐户"
    :visible.sync="flag"
    :close-on-click-modal="false"
    width="550px"
  >
    <el-form ref="form" :rules="rules" :model="form" label-width="150px">
      <el-form-item label="城市" prop="province_id">
        <el-row v-if="showCity">
          <el-col :span="11">
            <el-form-item prop="province_id">
              <el-select
                v-model="form.province_id"
                placeholder="请选择"
                style="width: 100%"
                @change="updateCity(true)"
              >
                <el-option
                  v-for="(item, index) in area"
                  :key="index"
                  :label="item.regionName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">&nbsp; </el-col>
          <el-col :span="11">
            <el-form-item prop="city_id">
              <el-select
                v-model="form.city_id"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in city"
                  :key="index"
                  :label="item.regionName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-else prop="province_id">
          <el-select
            v-model="form.province_id"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in area"
              :key="index"
              :label="item.regionName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
      <el-form-item label="机构全称" prop="name">
        <el-input
          v-model.trim="form.name"
          placeholder="请输入机构全称"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构简称" prop="org_abbreviation">
        <el-input
          v-model.trim="form.org_abbreviation"
          placeholder="请输入机构简称"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构编码" prop="org_mark">
        <el-input
          v-model.trim="form.org_mark"
          placeholder="请输入两位机构编码"
          maxlength="2"
          @change="lose_blur($event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="username">
        <el-input
          size="medium"
          v-model="form.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="管理员姓名" prop="user_name">
        <el-input
          v-model.trim="form.user_name"
          placeholder="请输入管理员姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="管理员手机" prop="mobile_phone">
        <el-input
          v-model="form.mobile_phone"
          placeholder="请输入管理员手机"
        ></el-input>
      </el-form-item>
      <!--<el-form-item label="身份证"
                    prop="id_number">
        <el-input size="medium"
                  v-model="form.id_number"
                  placeholder="请输入正确的身份证信息"></el-input>
      </el-form-item>-->
      <el-form-item label="新密码" prop="password">
        <el-input
          v-model="form.password"
          placeholder="不设置则不修改"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="password_affirm">
        <el-input
          v-model="form.password_affirm"
          placeholder="请确认新密码"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员协会logo" prop="image_url" class="up-form-item">
        <div class="upfile-wrap">
          <image-up
            :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
            :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
            :imgval.sync="form.image_url"
            :cover='showImg'
            :showScaleBig="false"
            :default-img="DefaultImg"
            :dt="'12vh'"
          ></image-up>
          <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
        </div>
      </el-form-item>
      <!--<el-form-item label="考评模板"
                    prop="evaluate_template">
        <el-select v-model="form.evaluate_template"
                   placeholder="请选择考评模板"
                   style="width: 100%;">
          <el-option
              v-for="(item, index) in tpl"
              :key="index"
              :label="item.key"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>-->
      <template v-if="isFive">
        <el-form-item label="五人制会员协会状态">
          <el-switch v-model="formData.status_five"></el-switch>
        </el-form-item>
        <el-form-item label="创建五人制培训班">
          <el-switch v-model="formData.class_authorization_five"></el-switch>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="会员协会状态">
          <el-switch v-model="formData.status"></el-switch>
        </el-form-item>
        <el-form-item label="创建培训班">
          <el-switch v-model="formData.class_authorization"></el-switch>
        </el-form-item>
      </template>
     
      <!-- 仅十一人制度提供数据大屏 -->
      <template v-if="!isFive">
        <el-form-item label="数据大屏">
          <el-switch v-model="formData.is_statistical"></el-switch>
        </el-form-item>
      </template>
      
      <div class="btns">
        <el-button type="primary" :loading="repeatSubmit" @click="check"
          >保存</el-button
        >
        <el-button type="danger" @click="onCancel">取消</el-button>
        <!-- <div class="btn save" @click="check">保存</div>
        <div class="btn cancel" @click="onCancel">取消</div> -->
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { area_list } from "@/assets/js/region";
import { editOrganization } from "@/api/system_manager/api";
import { getPwdSalt } from "@/api/common/api";
import { hex_hmac_sha256 } from "@/assets/js/sha";
const HOSTURL = process.env.VUE_APP_URL;
import DefaultImg from '@/assets/images/org_logo.png'
export default {
  name: "org-edit",
  props: ["visible", "info", "isFive"],
  components:{
    "image-up": () => import("@/components/UpImage/UpImage"),
  },
  data() {
    const tpl = [
      { key: "机构考评模板", value: 0 },
      { key: "讲师考评模板", value: 1 },
    ];
    return {
      DefaultImg,
      repeatSubmit: false,
      showCity: false,
      area: area_list,
      city: [],
      mark_msg: "",
      mark_flag: false,
      phone_flag: false, // 用于标记后台返回错误提示，进行重校验
      phone_msg: "", // 存储后台错误提示
      username_flag: false, // 用于标记后台返回错误提示，进行重校验
      username_msg: "", // 存储后台错误提示
      idCard_flag: false, // 标记后台返回错误提示，进行重校验
      idCard_tips: "", // 后台返回身份证重复提示
      tpl: tpl,
      showImg : this.info.profile_picture && HOSTURL + this.info.profile_picture,
      /* 提交时所需要的表单数据 */
      form: {
        org_id: this.info.org_id,
        org_mark: this.info.org_mark,
        name: this.info.name,
        org_abbreviation: this.info.org_abbreviation,
        user_name: this.info.user_name,
        mobile_phone: this.info.mobile_phone,
        image_url:"",
        //          id_number: this.info.id_number,
        password: "",
        password_affirm: "",
        status: false,
        status_five: false,
        class_authorization: this.info.class_authorization,
        class_authorization_five: this.info.class_authorization_five,
        is_statistical: this.info.is_statistical,
        province_id: this.info.province_id.toString(),
        city_id: this.info.city_id.toString(),
        evaluate_template: 0,
        username: this.info.username,
      },
      /* 展示时所需特殊表单数据 */
      formData: {
        status: false,
        status_five: false,
        class_authorization: false,
        class_authorization_five: false,
        is_statistical: false,
      },
      rules: {
        province_id: [
          { required: true, message: "请选择机构所在地", trigger: "change" },
        ],
        city_id: [
          { required: true, message: "请选择机构所在地", trigger: "change" },
        ],
        evaluate_template: [
          { required: true, message: "请选择考评模板", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入机构全称", trigger: "blur" },
          // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        org_abbreviation: [
          { required: true, message: "请输入机构简称", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "长度在 1 到 15 个字符",
            trigger: "blur",
          },
        ],
        user_name: [
          { required: true, message: "请输入管理员姓名", trigger: "blur" },
          // {min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        username: [
          {
            required: true,
            validator: (rule, val, callback) => {
              if (val) {
                if (!this.username_flag) {
                  callback();
                } else {
                  this.username_flag = false;
                  callback(new Error(this.username_msg));
                }
              } else {
                callback(new Error("请输入用户名"));
              }
            },
            trigger: "blur",
          },
        ],
        //          id_number: [
        //            /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
        //            {
        //              required: true,
        //              validator: (rule, val, callback) => {
        //                if (this.$yioks.idCard_number(val)) {
        //                  if (!this.idCard_flag) {
        //                    callback();
        //                  } else {
        //                    this.idCard_flag = false;
        //                    callback(new Error(this.idCard_tips));
        //                  }
        //                } else {
        //                  callback(new Error("请输入正确的身份证信息"));
        //                }
        //              },
        //              trigger: "blur"
        //            }
        //          ],
        mobile_phone: [
          {
            required: true,
            validator: (rule, val, callback) => {
              if (this.$yioks.mobile_phone(val)) {
                if (!this.phone_flag) {
                  callback();
                } else {
                  this.phone_flag = false;
                  callback(new Error(this.phone_msg));
                }
              } else {
                callback(new Error("请输入有效的11位手机号"));
              }
            },
            trigger: "blur",
          },
        ],
        org_mark: [
          {
            required: true,
            validator: (rule, val, callback) => {
              if (val && val.length === 2) {
                if (!this.mark_flag) {
                  callback();
                } else {
                  this.phone_flag = false;
                  callback(new Error(this.mark_msg));
                }
              } else {
                callback(new Error("请输入两位机构编码"));
              }
            },
            trigger: "blur",
          },
        ],
        password: [
          /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
          {
            required: false,
            validator: (rule, val, callback) => {
              if (!val) {
                callback();
                return false;
              }
              if (this.$yioks.pwd(val)) {
                callback();
              } else {
                callback(new Error("8—16位字母（区分大小写）和数字组合"));
              }
            },
            trigger: "blur",
          },
        ],
        password_affirm: [
          /*{min: 8, max: 16, message: '8—16位字符，字母（区分大小写）和数字组合', trigger: 'blur'},*/
          {
            required: false,
            validator: (rule, val, callback) => {
              if (val !== this.form.password) {
                callback(new Error("两次输入密码不一致"));
              }
              if (!val) {
                callback();
                return false;
              }
              if (this.$yioks.pwd(val)) {
                callback();
              } else {
                callback(new Error("8—16位字母（区分大小写）和数字组合"));
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    flag: {
      set(bool) {
        this.resetForm();
        this.$emit("flag", bool, false);
      },
      get() {
        return this.visible;
      },
    },
  },
  created() {
    this.transformData();
  },
  methods: {
    transformData() {
      /* 是否显示 城市 */
      this.showCity = Boolean(this.info.org_level == "city");
      if (this.showCity) {
        this.updateCity(false);
      }
      const { status_five, class_authorization_five } = this.info;
      /* 设置表单 radio 开关 */
      switch (this.info.status) {
        case "Active":
          this.$set(this.formData, "status", true);
          break;
        case "Abnormal":
          this.$set(this.formData, "status", false);
          break;
        default:
          this.$set(this.formData, "status", false);
          break;
      }
      this.$set(this.formData, "status_five", false)
      if(status_five) {
        if( status_five === 'Active') this.$set(this.formData, "status_five", true);
        if( status_five === 'Abnormal') this.$set(this.formData, "status_five", false);
      }
      this.$set(this.formData, "class_authorization_five", false)
      if(class_authorization_five) {
        if( class_authorization_five === 1) this.$set(this.formData, "class_authorization_five", true);
        if( class_authorization_five === 0) this.$set(this.formData, "class_authorization_five", false);
      }
      switch (this.info.class_authorization) {
        case 1:
          this.$set(this.formData, "class_authorization", true);
          break;
        case 0:
          this.$set(this.formData, "class_authorization", false);
          break;
        default:
          this.$set(this.formData, "class_authorization", false);
          break;
      }
      switch (this.info.is_statistical) {
        case 1:
          this.$set(this.formData, "is_statistical", true);
          break;
        case 0:
          this.$set(this.formData, "is_statistical", false);
          break;
        default:
          this.$set(this.formData, "is_statistical", false);
          break;
      }
    },
    check() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      const { status_five, class_authorization_five } = this.formData;
      /* 设置表单 radio 值 */
      switch (this.formData.status) {
        case true:
          this.$set(this.form, "status", "Active");
          break;
        case false:
          this.$set(this.form, "status", "Abnormal");
          break;
        default:
          this.$set(this.form, "status", "Abnormal");
          break;
      }
      if(status_five) {
        this.$set(this.form, "status_five", "Active");
      } else {
        this.$set(this.form, "status_five", "Abnormal");
      }
      if(class_authorization_five) {
        this.$set(this.form, "class_authorization_five", 1);
      } else {
        this.$set(this.form, "class_authorization_five", 0);
      }
      switch (this.formData.class_authorization) {
        case true:
          this.$set(this.form, "class_authorization", 1);
          break;
        case false:
          this.$set(this.form, "class_authorization", 0);
          break;
        default:
          this.$set(this.form, "class_authorization", 0);
          break;
      }
      switch (this.formData.is_statistical) {
        case true:
          this.$set(this.form, "is_statistical", 1);
          break;
        case false:
          this.$set(this.form, "is_statistical", 0);
          break;
        default:
          this.$set(this.form, "is_statistical", 0);
          break;
      }
      /* 提交 */
      this.onSubmit();
    },
    request(data) {
      editOrganization(data)
        .then((res) => {
          const { msg, status } = res.data;
          if (Number(status) == 0) {
            this.$emit("flag", false, true);
            // return;
          }
          if (Number(status) == 405) {
            this.phone_msg = msg;
            this.phone_flag = true;
            this.$refs["form"].validateField("mobile_phone");
          }
          if (Number(status) == 402) {
            this.username_msg = msg;
            this.username_flag = true;
            this.$refs["form"].validateField("username");
          }
          if (Number(status) === 513) {
            this.mark_flag = true;
            this.mark_msg = msg;
            this.$refs["form"].validateField("org_mark");
          }
          /*if (Number(status) == 415) {
              // console.log(msg);
              this.idCard_tips = msg;
              this.idCard_flag = true;
              this.$refs["form"].validateField("id_number");
            }*/
          this.repeatSubmit = false;
        })
        .catch((err) => {
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    updateCity(flag) {
      this.city = this.$yioks.updateCity(this.form.province_id, this.area);
      flag && this.$set(this.form, "city_id", this.city[0].id);
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          if (this.form.password != "") {
            getPwdSalt({})
              .then((res) => {
                if (Number(res.data.status) === 0) {
                  const { regist_salt } = res.data.result.data;
                  const pwd = hex_hmac_sha256(
                    regist_salt,
                    this.form.password
                  ).toUpperCase();
                  // 确认密码
                  const pwd_affirm = hex_hmac_sha256(
                    regist_salt,
                    this.form.password_affirm
                  ).toUpperCase();
                  // 解决密码闪动
                  const data = {
                    ...this.form,
                    password: pwd,
                    regist_salt: regist_salt,
                    password_affirm: pwd_affirm,
                  };
                  this.request(data);
                  return;
                }
                throw new Error(res);
              })
              .catch((err) => {
                this.repeatSubmit = false;
                console.error(err);
              });
          } else {
            this.request( this.form);
          }
        } else {
          this.repeatSubmit = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    onCancel() {
      this.flag = false;
    },
    resetForm() {
      this.$refs["form"].resetFields();
    },
    lose_blur(val) {
      this.form.org_mark = this.$yioks.privateCode(val)
        ? this.$yioks.privateCode(val)
        : "";
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.el-button--danger
  background-color $color_err
</style>
